import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { finalize, Subscription, take } from 'rxjs';
import { UserService } from 'src/app/modules/usuario/service/user.service';
import { ToastService } from 'src/app/modules/shared/services/toast/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ISortState } from './emitir-documento.interface';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { LoadingService } from '../loading/loading.service';
import { ModalComponent } from '../../components/modal/modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TaxisService } from '../../../taxi/services/taxis.service';
import { PermissaoService } from '../../../permissao/services/permissao.service';
import { handleHttpError } from '../../utils/http-utils';
import { IPortador } from '../../../taxi/models/folha-dados.interface';
import {
  IAssinanteSelecionado,
  ITipoAssinante,
  TipoAssinante,
} from '../../../permissao/models/documento-permissao.interface';

export const MSG_TIPO_ASSINANTE_OBRIGATORIO =
  'O tipo do assinante é obrigatório';
export const MSG_TIPO_ASSINANTE_DUPLICADO = 'tipo de assinante já vinculado';

@Component({
  selector: 'app-emitir-documento',
  templateUrl: './emitir-documento.component.html',
  styleUrls: ['./emitir-documento.component.scss'],
})
export class EmitirDocumentoComponent {
  @Input() isEditMode: boolean = false;
  @Input() title: string = '';

  @Input() fromCarteira: boolean = false;

  @Input() fromFolha: boolean = false;

  @Input() aditionalInfo: { label: string; value: string | number }[] = [];
  @Input() addedUsers: any[] = [];
  @Input() numeroPermissao: string | null = null;

  @Input() addedPortadores: any[] = [];

  @Input() validade: string = '';
  // Carteira emitida pela permissão: data obrigatória e independente da validade (PBI 116547).
  // Desligada por padrão: o caminho pelo veículo e os demais documentos também usam este componente.
  @Input() exibirProximaVistoria: boolean = false;
  @Input() proximaVistoria: string = '';
  @Input() idsSelecionados: any[] = [];

  @Output() onCreateSubmit = new EventEmitter<any>();
  @Output() onEditSubmit = new EventEmitter<any>();
  @Output() addedUsersChange = new EventEmitter<any>();

  @Output() addedPortadorChange = new EventEmitter<any>();
  @Output() addedValidadeChange = new EventEmitter<any>();
  @Output() addedProximaVistoriaChange = new EventEmitter<any>();
  documentoId: string | null = null;
  veiculoId: string | null = null;
  certidaoId: string | null = null;
  permissaoId: string | null = null;
  transicaoId: string | null = null;
  form: FormGroup;
  formPortador: FormGroup;
  subscriptions: Subscription[] = [];
  selectedUser: any = null;
  allUsers: any[] = [];

  userInput: string = '';
  selectUserId: any = null;

  permissionarios: IPortador[] = [];
  idPermissionarioSelecionado: string | null = null;
  permissionarioInput: string = '';

  auxiliares: IPortador[] = [];
  idAuxiliarSelecionado: string | null = null;
  auxiliarInput: string = '';

  tiposAssinante: ITipoAssinante[] = [];
  opcoesTipoAssinante: { id: TipoAssinante; nome: string }[] = [];
  tipoAssinanteSelecionado: TipoAssinante | null = null;
  tipoAssinanteInput: string = '';

  listaPermissoes: any[] = [];
  assinaturas: any;
  checkBoxControll: boolean = false;

  sortState: ISortState = {
    sortProperty: 'nome',
    sortDirection: 'asc',
  };
  pageSize: number = 10;
  pageIndex: number = 0;
  totalPages: number = 1;
  totalElements: number = 0;
  displayedColumns: string[] = [
    'nome',
    'cargo',
    'tipoEntidade',
    'removeAction',
  ];

  displayedPortadorColumns: string[] = ['checkBox', 'nomePortador', 'tipo'];

  dataSource = new MatTableDataSource<any>([]);
  dataSourcePortador = new MatTableDataSource<IPortador>([]);
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  buttonInclusaoDisabled: boolean = false;
  buttonExclusaoDisabled: boolean = false;
  buttonEdicaoDisabled: boolean = false;
  disabledTooltipMessage: string = 'Ação não permitida';
  currentRoute: string = '';

  constructor(
    private fb: FormBuilder,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private toastService: ToastService,
    public dialog: MatDialog,
    private location: Location,
    private taxiService: TaxisService,
    private permissaoService: PermissaoService,
  ) {
    this.form = this.fb.group({});
    this.formPortador = this.fb.group({});
  }

  ngOnInit() {
    this.idsSelecionados = [];

    this.dataSource.paginator = this.paginator;
    this.currentRoute = this.router.url;
    this.veiculoId = sessionStorage.getItem('veiculoId');
    this.certidaoId = sessionStorage.getItem('certidaoId');
    this.transicaoId = sessionStorage.getItem('transicaoId');
    this.permissaoId = sessionStorage.getItem('permissaoId');

    if (this.fromCarteira) {
      this.displayedColumns = [
        'nome',
        'cargo',
        'tipoEntidade',
        'tipoAssinante',
        'removeAction',
      ];
      this.carregarTiposAssinante();
    }

    if (this.fromCarteira || this.fromFolha) {
      this.onGetPortador();
    }

    if (!this.hasCadastroDeOrigem()) {
      this.goBack();
    }
    this.searchUsers();

    this.route.paramMap.subscribe((params) => {
      const documentoId = params.get('id');
      if (documentoId) {
        this.documentoId = documentoId;
        this.isEditMode = true;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['addedUsers']) {
      this.dataSource.data = this.addedUsers;
      this.setPaginatorValues();
    }

    if (changes['idsSelecionados']) {
      const value = changes['idsSelecionados'].currentValue;
      this.idsSelecionados = [];
      this.idsSelecionados.push(value);
      this.idsSelecionados = this.formatOnlyIds(this.idsSelecionados);

      if (this.fromCarteira && this.dataSourcePortador.data.length) {
        this.sincronizarCondutorCarteira();
      }
    }
  }

  formatOnlyIds(lista: any[]) {
    return lista.map((item) => item?.id ?? null);
  }

  onSubmit() {
    if (
      this.fromCarteira &&
      (!this.validade ||
        (this.exibirProximaVistoria && !this.proximaVistoria) ||
        !this.idPermissionarioSelecionado ||
        this.idsSelecionados.length <= 0)
    ) {
      return this.toastService.showError('Campos obrigatórios não preenchidos');
    }
    if (
      this.fromCarteira &&
      this.dataSource.data.some(
        (assinante: IAssinanteSelecionado) => !assinante.tipoAssinante,
      )
    ) {
      return this.toastService.showError(MSG_TIPO_ASSINANTE_OBRIGATORIO);
    }
    if (this.fromFolha && this.idsSelecionados.length <= 0) {
      return this.toastService.showError(
        'Selecione ao menos um condutor para emitir a folha de dados',
      );
    }
    // Validação local do assinante: a mensagem da API ("Lista de Assinantes
    // Obrigatória") não é a do PBI e varia por endpoint — por isso barramos aqui
    // e exibimos o texto do PBI antes do submit.
    if (this.fromFolha && this.dataSource.data.length <= 0) {
      return this.toastService.showError(
        'Selecione ao menos um assinante para emitir a folha de dados',
      );
    }
    if (!this.form.valid) {
      return this.toastService.showError('Campos obrigatórios não preenchidos');
    }

    this.isEditMode ? this.openEditDialog() : this.handleCreateSubmit();
  }

  openEditDialog(): void {
    const modalTitle: string = 'Editar assinantes';
    const modalContent: string =
      'Todas as assinaturas realizadas serão removidas.';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.handleEditSubmit.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
      },
    });
  }

  handleEditSubmit() {
    if (!this.form.valid) {
      return this.toastService.showError('Campos obrigatórios não preenchidos');
    }
    if (this.fromCarteira) {
      this.addedValidadeChange.emit(this.validade);
      if (this.exibirProximaVistoria) {
        this.addedProximaVistoriaChange.emit(this.proximaVistoria);
      }
      this.addedPortadorChange.emit(
        this.filtrarPortadoresPorIds(
          this.dataSourcePortador.data,
          this.idsSelecionados,
        ),
      );
    }
    this.onEditSubmit.emit();
  }

  // A tela precisa de um cadastro de origem: veículo, certidão ou permissão
  // (documento emitido pela permissão não tem vínculo com veículo).
  private hasCadastroDeOrigem(): boolean {
    return !!(this.veiculoId || this.certidaoId || this.permissaoId);
  }

  handleCreateSubmit() {
    if (!this.hasCadastroDeOrigem()) {
      this.toastService.showError();
      return this.goBack();
    }

    if (!this.form.valid) {
      return this.toastService.showError('Campos obrigatórios não preenchidos');
    }
    if (this.fromCarteira) {
      this.addedValidadeChange.emit(this.validade);
      if (this.exibirProximaVistoria) {
        this.addedProximaVistoriaChange.emit(this.proximaVistoria);
      }
    }
    if (this.fromCarteira || this.fromFolha) {
      this.addedPortadorChange.emit(
        this.filtrarPortadoresPorIds(
          this.dataSourcePortador.data,
          this.idsSelecionados,
        ),
      );
    }

    this.onCreateSubmit.emit();
  }

  filtrarPortadoresPorIds(dataSource: any[], idsSelecionados: number[]): any[] {
    return dataSource.filter((item) => idsSelecionados.includes(item.id));
  }

  onSelectUser(value: any) {
    this.setFormValue(value, 'idVeiculo');

    if (value) {
      const veiculo = this.allUsers.find((u) => u.id === value);
      this.selectedUser = veiculo;
    } else {
      this.selectedUser = null;
    }
  }

  setFormValue(value: any, formInput: string) {
    if (value) {
      this.form.patchValue({ [formInput]: value });
    } else {
      this.form.patchValue({ [formInput]: '' });
    }
  }

  searchUsers(searchTerm: string = '') {
    this.loadingService.showLoading();

    this.userService
      .getListaAssinantes(0, searchTerm)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        }),
      )
      .subscribe({
        next: (res: any) => {
          this.allUsers = res.content;
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        },
      });
  }

  selectUser(user: any) {
    this.selectedUser = user;
    this.form.patchValue({ userFilterInput: user.nome });
  }

  keydownSelectUser(event: KeyboardEvent, user: any) {
    if (
      event.key === 'Spacebar' ||
      event.key === 'Enter' ||
      event.key === ' '
    ) {
      event.preventDefault();
      this.selectUser(user);
    }
  }

  onSortChange(sortProperty: ISortState['sortProperty']) {
    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.sortProperty = sortProperty;
      this.sortState.sortDirection = 'asc';
    }

    const sortedData = this.dataSource.data.sort((a, b) => {
      const valueA = a[sortProperty];
      const valueB = b[sortProperty];
      let comparison = 0;

      if (valueA > valueB) {
        comparison = 1;
      } else if (valueA < valueB) {
        comparison = -1;
      }

      return this.sortState.sortDirection === 'asc' ? comparison : -comparison;
    });

    this.dataSource.data = sortedData;
  }

  onAddSelectedUser() {
    if (!this.selectUserId) {
      return this.toastService.showError('Selecione um usuário.');
    }

    if (this.fromCarteira && !this.tipoAssinanteSelecionado) {
      return this.toastService.showError(MSG_TIPO_ASSINANTE_OBRIGATORIO);
    }

    if (
      this.addedUsers.findIndex(
        (u) =>
          u.id === this.selectUserId || u.idAssinante === this.selectUserId,
      ) >= 0
    ) {
      return this.toastService.showError(`O usuário já está adicionado.`);
    }

    if (
      this.fromCarteira &&
      this.addedUsers.some(
        (u: IAssinanteSelecionado) =>
          u.tipoAssinante === this.tipoAssinanteSelecionado,
      )
    ) {
      return this.toastService.showError(MSG_TIPO_ASSINANTE_DUPLICADO);
    }

    const userIndex = this.dataSource.data.findIndex(
      (u) => u.id === this.selectUserId,
    );
    if (userIndex < 0) {
      let users = this.dataSource.data;
      users.push(
        this.fromCarteira
          ? {
              ...this.selectedUser,
              tipoAssinante: this.tipoAssinanteSelecionado,
            }
          : this.selectedUser,
      );
      this.dataSource.data = users;
      this.addedUsers = users;
      this.addedUsersChange.emit(this.addedUsers);
    }

    this.setPaginatorValues();

    this.selectUserId = null;
    this.userInput = '';
    this.selectedUser = null;
    this.tipoAssinanteSelecionado = null;
    this.tipoAssinanteInput = '';
  }

  carregarTiposAssinante() {
    this.subscriptions.push(
      this.permissaoService
        .getTiposAssinante()
        .pipe(take(1))
        .subscribe({
          next: (tipos) => {
            this.tiposAssinante = tipos;
            this.opcoesTipoAssinante = tipos.map((tipo) => ({
              id: tipo.valor,
              nome: tipo.descricao,
            }));
          },
          error: (erro: HttpErrorResponse) =>
            handleHttpError(this.toastService, erro),
        }),
    );
  }

  onSelectTipoAssinante(valor: TipoAssinante | null) {
    this.tipoAssinanteSelecionado = valor;
    this.tipoAssinanteInput =
      this.opcoesTipoAssinante.find((opcao) => opcao.id === valor)?.nome ?? '';
  }

  descricaoTipoAssinante(valor: TipoAssinante | null | undefined): string {
    return (
      this.tiposAssinante.find((tipo) => tipo.valor === valor)?.descricao ?? '-'
    );
  }

  setPaginatorValues() {
    this.totalElements = this.dataSource.data.length;
    this.totalPages = Number(
      (1 + this.totalElements / this.pageSize).toPrecision(1),
    );
  }

  removeUser(idAssinante: string) {
    const updatedProfileUsers = this.dataSource.data.filter(
      (user) => user.id !== idAssinante,
    );
    this.dataSource.data = updatedProfileUsers;
    this.addedUsers = updatedProfileUsers;
    this.addedUsersChange.emit(this.addedUsers);
    this.setPaginatorValues();
  }

  handleCancel() {
    this.location.back();
  }

  goBack() {
    this.location.back();
  }

  // ===================== Portador =====================
  onGetPortador() {
    this.loadingService.showLoading();

    this.subscriptions.push(
      this.taxiService
        .getPoertador(this.numeroPermissao)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          }),
        )
        .subscribe(
          (response: any) => {
            this.dataSourcePortador.data = response;
            if (this.fromCarteira) {
              this.permissionarios = this.dataSourcePortador.data.filter(
                (portador) => portador.tipo === 'Permissionario',
              );
              this.auxiliares = this.dataSourcePortador.data.filter(
                (portador) => portador.tipo === 'Auxiliar',
              );
              this.sincronizarCondutorCarteira();
            }
          },
          (erro) => {
            if (this.fromFolha && erro.status === 404) {
              this.toastService.showError(
                'Nenhum condutor ativo vinculado à permissão',
              );
            } else if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          },
        ),
    );
  }

  selectCheckBox(event: any, perm: any) {
    if (event.detail.checked) {
      this.idsSelecionados.push(perm.id);
    } else {
      this.checkBoxControll = false;
      this.idsSelecionados = this.idsSelecionados.filter(
        (id) => id !== perm.id,
      );
    }
  }

  // Carteira: o condutor é o auxiliar escolhido ou, sem auxiliar, o permissionário titular.
  onSelectPermissionario(id: string | null) {
    this.selecionarPermissionario(
      this.permissionarios.find((p) => p.id === id) ?? null,
    );
    this.atualizarCondutorCarteira();
  }

  onSelectAuxiliar(id: string | null) {
    this.selecionarAuxiliar(this.auxiliares.find((a) => a.id === id) ?? null);
    this.atualizarCondutorCarteira();
  }

  private sincronizarCondutorCarteira() {
    const condutorAtual = this.idsSelecionados[0];
    this.selecionarPermissionario(
      this.permissionarios.find((p) => p.id === condutorAtual) ??
        this.permissionarios[0] ??
        null,
    );
    this.selecionarAuxiliar(
      this.auxiliares.find((a) => a.id === condutorAtual) ?? null,
    );
    this.atualizarCondutorCarteira();
  }

  private selecionarPermissionario(permissionario: IPortador | null) {
    this.idPermissionarioSelecionado = permissionario?.id ?? null;
    this.permissionarioInput = permissionario?.nome ?? '';
  }

  private selecionarAuxiliar(auxiliar: IPortador | null) {
    this.idAuxiliarSelecionado = auxiliar?.id ?? null;
    this.auxiliarInput = auxiliar?.nome ?? '';
  }

  private atualizarCondutorCarteira() {
    const condutor =
      this.idAuxiliarSelecionado ?? this.idPermissionarioSelecionado;
    this.idsSelecionados = condutor ? [condutor] : [];
  }
}
